import React, { useEffect, useState } from "react";
import "./LandingPage.css";
import MintModel from "../MintModel/MintModel";
import CountUp from "react-countup";
import Header from "../Header/Header";
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import Web3 from "web3";
import {
  Mint_Contract_Abi,
  Mint_Contract_Address,
} from "../../utilies/constant";

export default function LandingPage() {
  const [modalShow, setModalShow] = React.useState(false);
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();

    const [getBNB_value, setgetBNB_value] = useState("");
    const [WhitelistStATUS, setWhitelistStATUS] = useState("loading");

    const [mintPrice, setMintPrice] = useState(0);
    const [Price, setPrice] = useState(0);
  
    const [totalsupply, settotalsupply] = useState(0);
  
    const webSupply = new Web3("https://brockrpc.io");
    const [spinner, setspinner] = useState(false);
const contractData = async () => {
    try {
      const contract = new webSupply.eth.Contract(
        Mint_Contract_Abi,
        Mint_Contract_Address
      );
      console.log(address, "Wallet");
      let tsupply =await contract.methods.totalSupply().call()
      let currentPrice= await contract.methods.checkPrice().call()
      setPrice(webSupply.utils.fromWei(currentPrice.toString()));
      settotalsupply(tsupply)
      if(address){
      
        
        let whitelistStatus= await contract.methods.isWhitelist(address).call()
        console.log(whitelistStatus,"whitelistStatus");
        if(whitelistStatus== false)
          setWhitelistStATUS("NO");
      else{
        setWhitelistStATUS("YES");
      }
        
  
      }
     
  
    } catch (error) {
      console.error("Error fetching contract data:", error);
    }
  };

    useEffect(() => {
      contractData();
    }, []);
  return (
    <div>
        <div className="bithu_v1_baner_sect" id="home">
    {/* <Header/> */}
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="bithu_v1_baner_left">
          <h2>BITROCK WALLET NFT GENESIS EDITION</h2>
          <h3>
            <span className="count"><CountUp end={totalsupply} duration={1} /></span> / 5555 Minted
          </h3>
          <div className="bithu_v1_baner_buttons">
            <button
              className="mint_btn hov_shape_show"
              onClick={() => setModalShow(true)}
            >
              Mint now
              <span className="hov_shape1">
                <img src="assets/images/hov_shape_L_dark.svg" alt="" />
              </span>
              <span className="hov_shape2">
                <img src="assets/images/hov_shape_L_dark.svg" alt="" />
              </span>
              <span className="square_hov_shape_dark" />
            </button>

{/* 
            <button className="widhlist_btn hov_shape_show">
              Whitelist Now
              <span className="hov_shape1">
                <img src="assets/images/hov_shape_L.svg" alt="" />
              </span>
              <span className="hov_shape2">
                <img src="assets/images/hov_shape_L.svg" alt="" />
              </span>
              <span className="square_hov_shape" />
            </button> */}

            <MintModel
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
          </div>
          {/* <h3>Are You Whitelisted ? {WhitelistStATUS} </h3>
          <button
                  className="modal_mint_btn hov_shape_show"
                  onClick={contractData}
                >
                  {spinner ? "Loading..." : "Check Whitelist Eligibility"}
                </button> */}
          <ul>
            <li>Max 25 NFTs per wallet . Price 300 BROCK</li>
            <li>
            Mint. Collect. Earn Rewards. Trade.
              {/* <span>UNTIL 25 APR 04:00H</span> */}
            </li>
            {/* <li>Presale : SOLDOUT</li> */}
          </ul>
        </div>
      </div>
      <div className="col-lg-6">
        {/* <div className="bithu_v1_baner_right">
          <div className="bithu_v1_baner_right_img_sect">
            <div className="mint_live_circle_sect">
              <div className="mint_live_circle">
                <span>
                  <img
                    src="assets/images/mint_live_down_arrow.svg"
                    alt=""
                  />
                </span>
                <span className="mint_live_text rotated-style">
                  <img src="assets/images/mint_live_text.png" alt="" />
                </span>
              </div>
            </div>
            <div className="bithu_v1_baner_right_img_bg">
              <img src="assets/images/home_img_bg.png" alt="" />
            </div>
            <div className="bithu_v1_baner_right_img">
              <img src="assets/images/Character1.png" alt="avater" />
            </div>
          </div>
        </div> */}
        <video className="w-100" src="assets/images/nftgs.mp4" autoPlay muted loop></video>
      </div>
    </div>
  </div>
</div>

    </div>
  );
}
